shadow$provide[267] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Transform:{enumerable:true, get:function() {
  return Transform;
}}});
var require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js = require("../base/parent.js");
class Transform extends require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "vertex", "fragment"];
  }
  vertex(shader, pass) {
    let left;
    return (left = __guard__(this._inherit("vertex"), x => x.vertex(shader, pass))) != null ? left : shader;
  }
  fragment(shader, pass) {
    let left;
    return (left = __guard__(this._inherit("fragment"), x => x.fragment(shader, pass))) != null ? left : shader;
  }
}
Transform.initClass();
function __guard__(value, xform) {
  return typeof value !== "undefined" && value !== null ? xform(value) : undefined;
}

};